import React from 'react'

export default function Footer(props) {
    return (
        <div className = "footer">
            <footer>
                <p>Copyright 2019 Party Planner</p>
            </footer>
        </div>
    )
}